import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { useSelector } from 'react-redux'
import { selectBrandColor, selectBrandColorText } from '../../../../flux/selectors/layout'
import { ReactComponent as RoundArrowRightIcon } from '../../../../images/svg/roundArrowRight.svg'
import { ReactComponent as RoundArrowLeftIcon } from '../../../../images/svg/roundArrowLeft.svg'

const StyledRoundArrow = styled.div(({
  dir, brandColor, brandColorText,
}) => {
  const dirStyle = (dir === 'right' ? { right: '-1px' } : { left: '-1px' })
  return {
    ...dirStyle,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: '2',
    opacity: '0.7',
    pointer: 'none',
    cursor: 'pointer',
    fill: brandColor,
    color: brandColorText,
  }
})

const CarouselArrowNavigator = ({
  swiper,
  isNextAvailable,
  isPrevAvailable,
}) => {
  const brandColor = useSelector(selectBrandColor) || 'transparent'
  const brandColorText = useSelector(selectBrandColorText) || 'transparent'

  const onNextArrowClick = () => swiper && swiper.slideNext()
  const onPrevArrowClick = () => swiper && swiper.slidePrev()

  return (
    <>
      {
          isPrevAvailable ? (
            <StyledRoundArrow
              data-test="ProductsLeftArrowNavigator"
              onClick={onPrevArrowClick}
              brandColor={brandColor}
              brandColorText={brandColorText}
              dir="left"
            >
              <RoundArrowRightIcon />
            </StyledRoundArrow>
          ) : null
        }
      {
        isNextAvailable ? (
          <StyledRoundArrow
            data-test="ProductsRightArrowNavigator"
            onClick={onNextArrowClick}
            brandColor={brandColor}
            brandColorText={brandColorText}
            dir="right"
          >
            <RoundArrowLeftIcon />
          </StyledRoundArrow>
        ) : null
      }
    </>
  )
}

CarouselArrowNavigator.propTypes = {
  swiper: PropTypes.shape({
    slideNext: PropTypes.func.isRequired,
    slidePrev: PropTypes.func.isRequired,
    activeIndex: PropTypes.number,
    isEnd: PropTypes.bool,
    isBeginning: PropTypes.bool,
  }),
  isNextAvailable: PropTypes.bool,
  isPrevAvailable: PropTypes.bool,
}

CarouselArrowNavigator.defaultProps = {
  isNextAvailable: true,
  isPrevAvailable: true,
  swiper: null,
}

CarouselArrowNavigator.displayName = 'CarouselArrowNavigator'
CarouselArrowNavigator.whyDidYouRender = true

export default CarouselArrowNavigator
